import orderBy from 'lodash/orderBy';

export enum DataQualityReportPeriod {
    fullday = 'fullday',
    keyhours = 'keyhours',
}

export const DataQualityReportPeriodMap = {
    [DataQualityReportPeriod.fullday]: '24-HOUR',
    [DataQualityReportPeriod.keyhours]: '2PM - 10PM',
};

export enum EnrollmentIdStatus {
    // Meter enrollment statuses
    DE_ENROLLED = 'De-enrolled',
    INELIGIBLE_FOLLOW_UP = 'Ineligible-Follow-up',
    SUBMITTED = 'Submitted',
    PRE_SUBMISSION = 'Pre-Submission',
    INELIGIBLE_FINAL = 'Ineligible-Final',
    CLOSED = 'Closed',
    MOVED_PROGRAMS = 'Moved Programs',
    NOT_SUBMITTED = 'Not Submitted',
    ENROLLMENT_ID_CHANGED = 'Enrollment ID changed',
    ENROLLED = 'Enrolled',
    NOT_PARTICIPATING = 'Not Participating',

    // Our statuses
    PR_CR = 'PR/CR',
    ERROR = 'Error',
}

export const enrollmentIdStatuses = orderBy(Object.values(EnrollmentIdStatus), item => item, 'asc');

export interface IFetchGroupedReadingsAvailabilityStats {
    companyId?: number | null;
    groupedByCompany?: boolean;
    startDate: Date;
    endDate: Date;
    period: DataQualityReportPeriod;
    format?: 'json' | 'csv';
}

export interface IGroupedReadingsAvailabilityStat {
    companyId: number;
    companyName: string;
    enrollmentId: string | null;
    nominationKw: number | null;
    statuses: string[] | null;
    updatedAt: string;
    stats: {
        [month: string]: number;
    };
}
